import ScatterDataset from '@fusioncharts/charts/src/dataset/scatter';
import { preDefStr, parseTooltext, pluck, getValidValue, pluckNumber,
  HUNDREDSTRING, getFirstValue, convertColor, getFirstColor, getFirstAlpha,
  parseUnsafeString } from '@fusioncharts/core/src/lib';
import KdTree from '@fusioncharts/charts/src/dataset/_internal/kdtree';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import errorscatterAnimation from './line.animation';
import errorscatterErrorAnimation from './error.animation';
var colorStrings = preDefStr.colors,
  COLOR_AAAAAA = colorStrings.AAAAAA,
  ROUND = preDefStr.ROUND,
  PERCENTAGESTRING = preDefStr.PERCENTAGESTRING,
  BLANK = '',
  UNDEF,
  COMMASPACE = ', ',
  POINTER = 'pointer',
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  OPTIONAL = 'optional',
  // TRACKER_FILL = 'rgba(192,192,192,' + (isIE ? 0.002 : 0.000001) + ')', // invisible but clickable
  M = 'M',
  H = 'H',
  V = 'V';
const DISAPPEARING = 'disappearing',
  APPEARING = 'appearing',
  UPDATING = 'updating';
// HTP = hasTouch ? TOUCH_THRESHOLD_PIXELS : CLICK_THRESHOLD_PIXELS,
addDep({
  name: 'errorscatterAnimation',
  type: 'animationRule',
  extension: errorscatterAnimation
});
addDep({
  name: 'errorscatterErrorAnimation',
  type: 'animationRule',
  extension: errorscatterErrorAnimation
});
class ErrorScatter extends ScatterDataset {
  constructor () {
    super();
    // eslint-disable-next-line good-practices/no-function-dependency
    this.drawCallbackFn = (state) => {
      return function () {
        if (state === 'disappearing') {
          this.hide();
        }
      };
    };
    // eslint-disable-next-line good-practices/no-function-dependency
    this.removeCallbackFn = function () {
      this.hide();
      this.shadow({ opacity: 0 });
    };
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'errorScatter';
  }
  ErrorValueConfigure () {
    var dataSet = this,
      conf = dataSet.config,
      JSONData = conf.JSONData,
      categories = dataSet.getFromEnv('dataSource').categories && dataSet.getFromEnv('dataSource').categories[0].category,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      setDataArr = JSONData.data,
      setDataLen = (setDataArr && setDataArr.length) || 0, // eslint-disable-line good-practices/no-single-usage-variable
      setData,
      dataObj,
      config,
      dataStore = dataSet.components.data,
      numberFormatter = dataSet.getFromEnv('number-formatter'),
      errorBarAlpha,
      errorBarThickness,
      errorBarShadow,
      errorBarWidth,
      errorBarColor,
      halfHorizontalErrorBar,
      halfVerticalErrorBar,
      horizontalErrorBarAlpha,
      verticalErrorBarAlpha,
      horizontalErrorBarColor,
      verticalErrorBarColor,
      horizontalErrorBarThickness,
      verticalErrorBarThickness,
      hErrorValue,
      vErrorValue,
      hErrorToolTipValue,
      vErrorToolTipValue,
      tooltipSepChar = pluck(chartAttr.tooltipsepchar, COMMASPACE),
      yAxisName = parseUnsafeString(chartAttr.yaxisname),
      xAxisName = parseUnsafeString(chartAttr.xaxisname),

      parentYAxis = conf.parentYAxis,
      setValue,
      formatedVal,
      toolText,
      horizontalErrorPercent,
      verticalErrorPercent,
      macroIndices,
      parserConfig,
      seriesname,
      infMin = -Infinity,
      infMax = +Infinity,
      maxErrorValue,
      minErrorValue,
      horizontal,
      vertical,
      vPositiveErrorValue,
      hNegativeErrorValue,
      hPositiveErrorValue,
      hPositiveSetTooltext,
      hPositiveErrorToolTipValue,
      hCPErrorToolText,
      hCPErrorToolTipValue,
      hNegativeErrorToolTipValue,
      hCNErrorToolTipValue,
      vPositiveErrorToolTipValue,
      hNegativeSetTooltext,
      vCPErrorToolTipValue,
      vNegativeErrorValue,
      vCNErrorToolText,
      vCNErrorToolTipValue,
      vPositiveSetTooltext,
      hCNErrorToolText,
      vCPErrorToolText,
      cumulativeValueOnErrorBar,
      vNegativeSetTooltext,
      vNegativeErrorToolTipValue,
      yMax = infMin,
      yMin = infMax,
      xMin = infMax,
      xMax = infMin,
      getTooltext = function (setTooltext, errorValue) {
        var tooltext;

        if (!conf.showTooltip) {
          tooltext = false;
        } else {
          if (formatedVal === null) {
            tooltext = false;
          } else if (setTooltext !== UNDEF) {
            macroIndices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 99, 100, 101, 102, 103, 104, 105, 106, 107, 109, 120, 121, 123, 124, 125, 126, 127, 128, 129, 130];
            parserConfig = {
              yaxisName: yAxisName,
              xaxisName: xAxisName,
              yDataValue: formatedVal,
              xDataValue: config.label,
              formattedValue: config.toolTipValue,
              horizontalErrorValue: hErrorValue,
              horizontalErrorDataValue: hErrorToolTipValue,
              verticalErrorValue: vErrorValue,
              verticalErrorDataValue: vErrorToolTipValue,
              horizontalErrorPercentValue: horizontalErrorPercent,
              verticalErrorPercentValue: verticalErrorPercent,
              label: config.label,
              // positiveErrorValue: hPositiveErrorToolTipValue,
              // negativeErrorValue: hNegativeErrorToolTipValue,
              horizontalPositiveErrorValue: config.useHorizontalErrorBar ? hPositiveErrorValue : UNDEF,
              horizontalPositiveErrorDataValue: config.useHorizontalErrorBar ? hPositiveErrorToolTipValue : UNDEF,
              horizontalNegativeErrorValue: halfHorizontalErrorBar ? UNDEF : hNegativeErrorValue,
              horizontalNegativeErrorDataValue: halfHorizontalErrorBar ? UNDEF : hNegativeErrorToolTipValue,
              verticalPositiveErrorValue: config.useVerticalErrorBar ? vPositiveErrorValue : UNDEF,
              verticalPositiveErrorDataValue: config.useVerticalErrorBar ? vPositiveErrorToolTipValue : UNDEF,
              verticalNegativeErrorValue: halfVerticalErrorBar ? UNDEF : vNegativeErrorValue,
              verticalNegativeErrorDataValue: halfVerticalErrorBar ? UNDEF : vNegativeErrorToolTipValue,
              errorValue: errorValue,
              errorDataValue: errorValue,
              errorPercentValue: config.errorPercentValue,
              errorPercentDataValue: config.errorPercentValue
            };
            tooltext = parseTooltext(setTooltext, macroIndices,
              parserConfig, setData, chartAttr, JSONData);
          } else {
            if (formatedVal === null) {
              tooltext = false;
            } else {
              if (conf.seriesNameInTooltip) {
                seriesname = getFirstValue(JSONData && JSONData.seriesname);
              }
              tooltext = seriesname ? seriesname + tooltipSepChar : BLANK;
              tooltext += setValue.x ? numberFormatter.xAxis(setValue.x) + tooltipSepChar : BLANK;
              tooltext += config.toolTipValue;
            }
          }
        }
        return tooltext;
      },
      i;

    conf.errorBarShadow = errorBarShadow = pluckNumber(chartAttr.errorbarshadow, chartAttr.showshadow, 0);
    conf.ignoreEmptyDatasets = pluckNumber(JSONData.ignoreemptydatasets, 0);
    conf.notHalfErrorBar = !pluckNumber(chartAttr.halferrorbar, 1);

    conf.errorBarAlpha = getFirstAlpha(pluck(
      JSONData.errorbaralpha, chartAttr.errorbaralpha));
    conf.errorBarWidth = errorBarWidth = pluckNumber(JSONData.errorbarwidth,
      chartAttr.errorbarwidth, 5);
    conf.errorBarColor = errorBarColor = convertColor(getFirstColor(
      pluck(JSONData.errorbarcolor, chartAttr.errorbarcolor,
        COLOR_AAAAAA)), errorBarAlpha);
    conf.errorBarThickness = errorBarThickness = pluckNumber(
      JSONData.errorbarthickness, chartAttr.errorbarthickness, 1);
    conf.shadowOpacity = errorBarShadow ? (errorBarAlpha / 250) : 0;

    conf.halfHorizontalErrorBar = halfHorizontalErrorBar = pluckNumber(chartAttr.halfhorizontalerrorbar, 1); // eslint-disable-line good-practices/no-single-usage-variable
    conf.halfVerticalErrorBar = halfVerticalErrorBar = pluckNumber(chartAttr.halfverticalerrorbar, 1); // eslint-disable-line good-practices/no-single-usage-variable

    (conf.initAnimation === UNDEF) && (conf.initAnimation = dataSet.getFromEnv('chart').initAnimation);

    horizontalErrorBarAlpha =
                    pluck(JSONData.horizontalerrorbaralpha,
                      JSONData.errorbaralpha,
                      chartAttr.horizontalerrorbaralpha, errorBarAlpha);

    verticalErrorBarAlpha = pluckNumber(
      JSONData.verticalerrorbaralpha, JSONData.errorbaralpha,
      chartAttr.verticalerrorbaralpha, errorBarAlpha);

    horizontalErrorBarColor = convertColor(pluck(
      JSONData.horizontalerrorbarcolor, JSONData.errorbarcolor,
      chartAttr.horizontalerrorbarcolor, errorBarColor),
    horizontalErrorBarAlpha
    );

    verticalErrorBarColor = convertColor(pluck(
      JSONData.verticalerrorbarcolor, JSONData.errorbarcolor,
      chartAttr.verticalerrorbarcolor, errorBarColor),
    verticalErrorBarAlpha
    );

    horizontalErrorBarThickness = pluckNumber(
      JSONData.horizontalerrorbarthickness,
      JSONData.errorbarthickness,
      chartAttr.horizontalerrorbarthickness,
      errorBarThickness);

    verticalErrorBarThickness = pluckNumber(
      JSONData.verticalerrorbarthickness,
      JSONData.errorbarthickness,
      chartAttr.verticalerrorbarthickness,
      errorBarThickness);

    conf.horizontalErrorBarWidth = pluckNumber(
      JSONData.horizontalerrorbarwidth,
      chartAttr.horizontalerrorbarwidth,
      errorBarWidth);

    conf.verticalErrorBarWidth = pluckNumber(
      JSONData.verticalerrorbarwidth,
      chartAttr.verticalerrorbarwidth,
      errorBarWidth);

    conf.cumulativeValueOnErrorBar =
                pluckNumber(JSONData.cumulativevalueonerrorbar, chartAttr.cumulativevalueonerrorbar, 1);

    for (i = 0; i < setDataLen; i++) {
      if (!setDataArr) {
        continue;
      }

      setData = setDataArr && setDataArr[i];
      dataObj = dataStore[i];
      config = dataObj && dataObj.config;

      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }

      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }

      // setErrorValue = numberFormatter.getCleanValue(setData.errorvalue);

      setValue = config.setValue;
      config.errorValue = setData.errorvalue;

      config.cumulativeValueOnErrorBar = cumulativeValueOnErrorBar =
                    pluckNumber(setData.cumulativevalueonerrorbar, conf.cumulativeValueOnErrorBar, 1);

      config.hErrorValue = hErrorValue = numberFormatter.getCleanValue(
        pluck(setData.horizontalerrorvalue, setData.errorvalue));
      hErrorToolTipValue = numberFormatter.xAxis(hErrorValue);

      config.vErrorValue = vErrorValue = numberFormatter.getCleanValue(
        pluck(setData.verticalerrorvalue, setData.errorvalue));
      vErrorToolTipValue = numberFormatter.dataLabels(vErrorValue);

      config.hPositiveErrorValue = hPositiveErrorValue = numberFormatter.getCleanValue(
        pluck(setData.horizontalpositiveerrorvalue, setData.positiveerrorvalue, hErrorValue));
      config.hNegativeErrorValue = hNegativeErrorValue = numberFormatter.getCleanValue(
        pluck(setData.horizontalnegativeerrorvalue, setData.negativeerrorvalue, hErrorValue));

      config.vPositiveErrorValue = vPositiveErrorValue = numberFormatter.getCleanValue(
        pluck(setData.verticalpositiveerrorvalue, setData.positiveerrorvalue, vErrorValue));
      config.vNegativeErrorValue = vNegativeErrorValue = numberFormatter.getCleanValue(
        pluck(setData.verticalnegativeerrorvalue, setData.negativeerrorvalue, vErrorValue));

      horizontalErrorPercent = (Math.round(((hErrorValue / setValue.x) * HUNDREDSTRING) * HUNDREDSTRING) /
        HUNDREDSTRING) + PERCENTAGESTRING;

      verticalErrorPercent = (Math.round(((vErrorValue / setValue.y) * HUNDREDSTRING) * HUNDREDSTRING) /
        HUNDREDSTRING) + PERCENTAGESTRING;

      hPositiveErrorToolTipValue =
                    numberFormatter.dataLabels(hPositiveErrorValue, parentYAxis);

      hPositiveSetTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext, hPositiveErrorToolTipValue), false));

      hNegativeErrorToolTipValue =
                    numberFormatter.dataLabels(hNegativeErrorValue, parentYAxis);

      hNegativeSetTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext, hNegativeErrorToolTipValue), false));

      vPositiveErrorToolTipValue =
                    numberFormatter.dataLabels(vPositiveErrorValue, parentYAxis);

      vPositiveSetTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext, vPositiveErrorToolTipValue), false));

      vNegativeErrorToolTipValue =
                    numberFormatter.dataLabels(vNegativeErrorValue, parentYAxis);

      vNegativeSetTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext, vNegativeErrorToolTipValue), false));
      hCPErrorToolText = hCNErrorToolText = vCPErrorToolText = vCNErrorToolText = UNDEF;
      if (cumulativeValueOnErrorBar) {
        hCPErrorToolTipValue =
                        numberFormatter.dataLabels(setValue.x + hPositiveErrorValue, parentYAxis);
        hCPErrorToolText = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext, hCPErrorToolTipValue), false));

        hCNErrorToolTipValue =
                        numberFormatter.dataLabels(setValue.x - hNegativeErrorValue, parentYAxis);
        hCNErrorToolText = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext, hCNErrorToolTipValue), false));

        vCPErrorToolTipValue =
                        numberFormatter.dataLabels(setValue.y + vPositiveErrorValue, parentYAxis);
        vCPErrorToolText = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext, vCPErrorToolTipValue), false));

        vCNErrorToolTipValue =
                        numberFormatter.dataLabels(setValue.y - vNegativeErrorValue, parentYAxis);
        vCNErrorToolText = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext, vCNErrorToolTipValue), false));
      }

      categories && categories[i] && (config.label =
                    getValidValue(parseUnsafeString(pluck(categories[i].tooltext, categories[i].label))));

      if (setData.horizontalpositiveerrorvalue || setData.positiveerrorvalue ||
                    setData.horizontalnegativeerrorvalue || setData.negativeerrorvalue) {
        config.halfHorizontalErrorBar = halfHorizontalErrorBar = 0;
      } else {
        config.halfHorizontalErrorBar = halfHorizontalErrorBar = conf.halfHorizontalErrorBar;
      }

      if (setData.verticalpositiveerrorvalue || setData.positiveerrorvalue ||
                    setData.verticalnegativeerrorvalue || setData.negativeerrorvalue) {
        config.halfVerticalErrorBar = halfVerticalErrorBar = 0;
      } else {
        config.halfVerticalErrorBar = halfVerticalErrorBar = conf.halfVerticalErrorBar;
      }

      if (setValue.x !== null) {
        maxErrorValue = setValue.x + Number(hPositiveErrorValue);
        minErrorValue = setValue.x - (halfHorizontalErrorBar ? 0 : Number(hNegativeErrorValue));

        xMax = Math.max(xMax, maxErrorValue, minErrorValue);
        xMin = Math.min(xMin, maxErrorValue, minErrorValue);
      }

      if (setValue.y !== null) {
        maxErrorValue = setValue.y + Number(vPositiveErrorValue);
        minErrorValue = setValue.y - (halfVerticalErrorBar ? 0 : Number(vNegativeErrorValue));

        yMax = Math.max(yMax, maxErrorValue, minErrorValue);
        yMin = Math.min(yMin, maxErrorValue, minErrorValue);
      }

      config.useHorizontalErrorBar = pluckNumber(setData.usehorizontalerrorbar,
        JSONData.usehorizontalerrorbar, chartAttr.usehorizontalerrorbar, 0);

      config.useVerticalErrorBar = pluckNumber(setData.useverticalerrorbar,
        JSONData.useverticalerrorbar, chartAttr.useverticalerrorbar, 1);

      config.errorValueConf = {};
      // horizontal error bar related segments
      horizontal = config.errorValueConf.horizontal = {};
      // this segments are mandatory as this part will show regardless show half error value is true or false
      horizontal.mandatory = {};
      // marker is one of the segment of error bar which denotes the error value
      horizontal.mandatory.marker = {
        errorValue: -(hPositiveErrorValue === null ? UNDEF : hPositiveErrorValue),
        tooltext: getTooltext(hPositiveSetTooltext, hPositiveErrorToolTipValue),
        errorBarColor: horizontalErrorBarColor,
        isHorizontal: true,
        errorBarThickness: horizontalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (horizontalErrorBarAlpha / 250) : 0
      };
      // limit denotes the error value or cummulative value of the error bar thats why we are calling it limit
      // as it conveys that the end of error bar
      horizontal.mandatory.limit = {
        errorValue: -(hPositiveErrorValue === null ? UNDEF : hPositiveErrorValue),
        tooltext: cumulativeValueOnErrorBar ? getTooltext(hCPErrorToolText, hCPErrorToolTipValue)
          : getTooltext(hPositiveSetTooltext, hPositiveErrorToolTipValue),
        errorBarColor: horizontalErrorBarColor,
        isHorizontal: true,
        errorBarThickness: horizontalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (horizontalErrorBarAlpha / 250) : 0,
        errorEdgeBar: true
      };
      // this segments are option as this part will show only show half error value is true
      horizontal.optional = {};
      // marker is one of the segment of error bar which denotes the error value
      horizontal.optional.marker = {
        errorValue: hNegativeErrorValue,
        tooltext: getTooltext(hNegativeSetTooltext, hNegativeErrorToolTipValue),
        errorBarColor: horizontalErrorBarColor,
        isHorizontal: true,
        errorBarThickness: horizontalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (horizontalErrorBarAlpha / 250) : 0
      };
      // limit denotes the error value or cummulative value of the error bar thats why we are calling it limit
      // as it conveys that the end of error bar
      horizontal.optional.limit = {
        errorValue: hNegativeErrorValue,
        tooltext: cumulativeValueOnErrorBar ? getTooltext(hCNErrorToolText, hCNErrorToolTipValue)
          : getTooltext(hNegativeSetTooltext, hNegativeErrorToolTipValue),
        errorBarColor: horizontalErrorBarColor,
        isHorizontal: true,
        errorBarThickness: horizontalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (horizontalErrorBarAlpha / 250) : 0,
        errorEdgeBar: true
      };
      // vertical error bar related segments
      vertical = config.errorValueConf.vertical = {};
      // this segments are mandatory as this part will show regardless show half error value is true or false
      vertical.mandatory = {};
      // marker is one of the segment of error bar which denotes the error value
      vertical.mandatory.marker = {
        errorValue: -(vPositiveErrorValue === null ? UNDEF : vPositiveErrorValue),
        tooltext: getTooltext(vPositiveSetTooltext, vPositiveErrorToolTipValue),
        errorBarColor: verticalErrorBarColor,
        errorBarThickness: verticalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (verticalErrorBarAlpha / 250) : 0
      };
      // limit denotes the error value or cummulative value of the error bar thats why we are calling it limit
      // as it conveys that the end of error bar
      vertical.mandatory.limit = {
        errorValue: -(vPositiveErrorValue === null ? UNDEF : vPositiveErrorValue),
        tooltext: cumulativeValueOnErrorBar ? getTooltext(vCPErrorToolText, vCPErrorToolTipValue)
          : getTooltext(vPositiveSetTooltext, vPositiveErrorToolTipValue),
        errorBarColor: verticalErrorBarColor,
        errorBarThickness: verticalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (verticalErrorBarAlpha / 250) : 0,
        errorEdgeBar: true
      };
      // this segments are option as this part will show only show half error value is true
      vertical.optional = {};
      // marker is one of the segment of error bar which denotes the error value
      vertical.optional.marker = {
        errorValue: vNegativeErrorValue,
        tooltext: getTooltext(vNegativeSetTooltext, vNegativeErrorToolTipValue),
        errorBarColor: verticalErrorBarColor,
        errorBarThickness: verticalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (verticalErrorBarAlpha / 250) : 0
      };
      // limit denotes the error value or cummulative value of the error bar thats why we are calling it limit
      // as it conveys that the end of error bar
      vertical.optional.limit = {
        errorValue: vNegativeErrorValue,
        tooltext: cumulativeValueOnErrorBar ? getTooltext(vCNErrorToolText, vCNErrorToolTipValue)
          : getTooltext(vNegativeSetTooltext, vNegativeErrorToolTipValue),
        errorBarColor: verticalErrorBarColor,
        errorBarThickness: verticalErrorBarThickness,
        shadowOpacity: errorBarShadow ? (verticalErrorBarAlpha / 250) : 0,
        errorEdgeBar: true
      };

      setValue = config.setValue;

      // errorPercentValue = (Math.round(((setErrorValue / setValue) * HUNDREDSTRING) * HUNDREDSTRING) /
      //               HUNDREDSTRING) + PERCENTAGESTRING;

      formatedVal = config.formatedVal;

      // Initial tooltext parsing
      if (!conf.showTooltip) {
        toolText = false;
      } else if (config.setTooltext !== UNDEF) {
        macroIndices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 99, 100, 101, 102, 103, 104, 105, 106, 107, 109, 120, 121, 123, 124, 125, 126, 127, 128, 129, 130];
        parserConfig = {
          yaxisName: yAxisName,
          xaxisName: xAxisName,
          yDataValue: formatedVal,
          xDataValue: config.label,
          formattedValue: config.toolTipValue,
          horizontalErrorValue: hErrorValue,
          horizontalErrorDataValue: hErrorToolTipValue,
          verticalErrorValue: vErrorValue,
          verticalErrorDataValue: vErrorToolTipValue,
          horizontalErrorPercentValue: horizontalErrorPercent,
          verticalErrorPercentValue: verticalErrorPercent,
          label: config.label,
          // positiveErrorValue: hPositiveErrorToolTipValue,
          // negativeErrorValue: hNegativeErrorToolTipValue,
          horizontalPositiveErrorValue: config.useHorizontalErrorBar ? hPositiveErrorValue : UNDEF,
          horizontalPositiveErrorDataValue: config.useHorizontalErrorBar ? hPositiveErrorToolTipValue : UNDEF,
          horizontalNegativeErrorValue: halfHorizontalErrorBar ? UNDEF : hNegativeErrorValue,
          horizontalNegativeErrorDataValue: halfHorizontalErrorBar ? UNDEF : hNegativeErrorToolTipValue,
          verticalPositiveErrorValue: config.useVerticalErrorBar ? vPositiveErrorValue : UNDEF,
          verticalPositiveErrorDataValue: config.useVerticalErrorBar ? vPositiveErrorToolTipValue : UNDEF,
          verticalNegativeErrorValue: halfVerticalErrorBar ? UNDEF : vNegativeErrorValue,
          verticalNegativeErrorDataValue: halfVerticalErrorBar ? UNDEF : vNegativeErrorToolTipValue,
          errorValue: config.errorValue,
          errorDataValue: numberFormatter.dataLabels(config.errorValue, conf.parentYAxis)
        };
        toolText = parseTooltext(config.setTooltext, macroIndices, parserConfig, setData, chartAttr,
          JSONData);
      } else {
        // determine the default tooltext then.
        if (formatedVal === null) {
          toolText = false;
        } else {
          if (conf.seriesNameInTooltip) {
            seriesname = getFirstValue(JSONData && JSONData.seriesname);
          }
          toolText = seriesname ? seriesname + tooltipSepChar : BLANK;
          toolText += setValue.x ? numberFormatter.xAxis(setValue.x) + tooltipSepChar : BLANK;
          toolText += config.toolTipValue;
        }
      }
      config.toolText = toolText;
    }

    conf.xMax = xMax;
    conf.xMin = xMin;
    conf.yMin = yMin;
    conf.yMax = yMax;
  }

  drawErrorValue () {
    var dataSet = this,
      conf = dataSet.config,
      setDataArr = dataSet.config.JSONData.data,
      dataSetLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      attr,
      i,
      errorGraphicsString,
      visible = dataSet.getState('visible'),
      dataStore = dataSet.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      graphics,
      // yAxisPVR = yAxis.getPVR(),
      // xAxisPVR = xAxis.getPVR(),
      isHorizontal,
      errorBarThickness,
      errorBarWidth,
      errorBarColor,
      setLink,
      xPos,
      yPos,
      useCrispErrorPath = 1,
      dataObj,
      setValue,
      animState,
      config,
      notRequiredHEB,
      notRequiredVEB,
      isHalfHorizontalErrorBar,
      isHalfVertictalErrorBar,
      crispY,
      crispX,
      errorPath,
      errorValPos,
      errorValuePosFactor,
      subType,
      errorBar,
      subErrorBar,
      segment,
      segmentType,
      currErrorTracker,
      errorValue,
      errorStartPos,
      halfErrorBarW,
      errorLineElem,
      plotXpos,
      plotYpos,
      errorBarSegmentLen,
      errorBarSegmentStartPos,
      l,
      k,
      errorValueConf,
      errorBarType,
      trackerTolerance,
      keys,
      animationManager = dataSet.getFromEnv('animationManager'),
      searchDataArr = [],
      errorTrackerConfig;

    // Loop through each data points
    for (i = 0; i < dataSetLen; i++) {
      dataObj = dataStore[i];
      errorTrackerConfig = dataObj.errorTrackerConfig = {};
      errorTrackerConfig.errorTrackerArr = [];
      config = dataObj && dataObj.config;
      setValue = config && config.setValue;

      errorValueConf = config.errorValueConf;

      // If plot value is found "null", continue the loop to next iteration.
      if (dataObj === UNDEF || setValue === UNDEF || setValue === null || !errorValueConf) {
        continue;
      }
      keys = Object.keys(graphics = dataObj.graphics);
      if (config.vErrorValue === null &&
                    config.vPositiveErrorValue === null && config.vNegativeErrorValue === null) {
        for (k = 0; k < keys.length; k++) {
          if (keys[k].match(/error-horizontal-/)) {
            animationManager.setAnimation({
              el: graphics[keys[k]],
              state: 'disappearing',
              callback: dataSet.drawCallbackFn('disappearing')
            });
            graphics[keys[k]].shadow({ opacity: 0 });
          }
        }
      }

      if (config.hErrorValue === null &&
                    config.hPositiveErrorValue === null && config.vPositiveErrorValue === null) {
        for (k = 0; k < keys.length; k++) {
          if (keys[k].match(/error-vertical-/)) {
            animationManager.setAnimation({
              el: graphics[keys[k]],
              state: 'disappearing',
              callback: dataSet.drawCallbackFn('disappearing')
            });
            graphics[keys[k]].shadow({ opacity: 0 });
          }
        }
      }

      if (config.hErrorValue === null && config.vErrorValue === null && config.hPositiveErrorValue &&
                    config.hNegativeErrorValue && config.vPositiveErrorValue && config.vNegativeErrorValue) {
        continue;
      }

      setLink = config.setLink;

      plotXpos = dataObj._xPos;
      plotYpos = dataObj._yPos;

      yPos = plotYpos;
      xPos = plotXpos;
      // errorBarType := horizontal / vertical
      for (errorBarType in errorValueConf) {
        if (!errorValueConf.hasOwnProperty(errorBarType)) {
          continue;
        }
        errorBar = errorValueConf[errorBarType];
        // subType := mandatory / optional
        for (subType in errorBar) {
          if (!errorBar.hasOwnProperty(subType)) {
            continue;
          }
          subErrorBar = errorBar[subType];
          // segmentType := marker / limit
          for (segmentType in subErrorBar) {
            if (!subErrorBar.hasOwnProperty(segmentType)) {
              continue;
            }
            animState = UNDEF;
            segment = subErrorBar[segmentType];
            attr = {};
            currErrorTracker = errorTrackerConfig.errorTrackerArr[0] = {};
            errorLineElem = null;

            currErrorTracker.tooltext = segment.tooltext;
            errorStartPos = yPos;
            errorValue = segment.errorValue;

            notRequiredHEB = !config.useHorizontalErrorBar && errorBarType === HORIZONTAL;
            notRequiredVEB = !config.useVerticalErrorBar && errorBarType === VERTICAL;
            isHalfHorizontalErrorBar = config.halfHorizontalErrorBar && errorBarType === HORIZONTAL && subType === OPTIONAL;
            isHalfVertictalErrorBar = config.halfVerticalErrorBar && errorBarType === VERTICAL && subType === OPTIONAL;
            if (notRequiredHEB || notRequiredVEB || isHalfHorizontalErrorBar || isHalfVertictalErrorBar) {
              animState = DISAPPEARING;
            } else if (errorValue === null || errorValue === UNDEF || isNaN(errorValue)) {
              animState = DISAPPEARING;
            } else {
              errorBarColor = segment.errorBarColor;
              isHorizontal = segment.isHorizontal;
              errorBarThickness = segment.errorBarThickness;

              errorBarWidth = isHorizontal ? conf.horizontalErrorBarWidth : conf.verticalErrorBarWidth;

              halfErrorBarW = (!visible) ? 0 : (errorBarWidth / 2);

              errorValuePosFactor = (!visible) ? 0 : -1;

              trackerTolerance = errorBarThickness > 5 ? (errorBarThickness) / 2 + 0.5 : 5.5 / 2;

              if (isHorizontal) {
                errorValPos = dataSet.getFromEnv('xAxis').getPixel(dataObj.config._x + (errorValue * errorValuePosFactor));
                crispY = errorValPos;
                crispX = xPos;

                if (useCrispErrorPath) {
                  crispY = Math.round(errorStartPos) + (errorBarThickness % 2 / 2);
                  crispX = Math.round(errorValPos) + (errorBarThickness % 2 / 2);
                }

                if (segment.errorEdgeBar) {
                  errorPath = [
                    M, crispX, crispY - halfErrorBarW,
                    V, (crispY + halfErrorBarW)
                  ];

                  errorBarSegmentLen = 2 * halfErrorBarW;
                  errorBarSegmentStartPos = crispY - halfErrorBarW;
                  for (l = trackerTolerance; l < errorBarSegmentLen; l += (2 * trackerTolerance)) {
                    searchDataArr.push({
                      x: crispX,
                      y: errorBarSegmentStartPos + l,
                      r: trackerTolerance,
                      index: i,
                      data: dataObj,
                      toolText: segment.tooltext,
                      barType: 'h'
                    });
                  }
                } else {
                  errorPath = [
                    M, xPos, crispY,
                    H, crispX
                  ];

                  errorBarSegmentLen = Math.abs(xPos - crispX);
                  errorBarSegmentStartPos = xPos > crispX ? crispX : xPos;
                  for (l = trackerTolerance; l < errorBarSegmentLen; l += (2 * trackerTolerance)) {
                    searchDataArr.push({
                      x: errorBarSegmentStartPos + l,
                      y: crispY,
                      r: trackerTolerance,
                      index: i,
                      data: dataObj,
                      toolText: segment.tooltext,
                      barType: 'h'
                    });
                  }
                }
              } else {
                // Vertical Error drawing
                errorValPos = dataSet.getFromEnv('yAxis').getPixel(dataObj.config._y + (errorValue * errorValuePosFactor));
                crispY = errorValPos;
                crispX = xPos;
                if (useCrispErrorPath) {
                  crispY = Math.round(errorValPos) + (errorBarThickness % 2 / 2);
                  crispX = Math.round(xPos) + (errorBarThickness % 2 / 2);
                }

                if (segment.errorEdgeBar) {
                  errorPath = [
                    M, crispX - halfErrorBarW, crispY,
                    H, (crispX + halfErrorBarW)
                  ];

                  errorBarSegmentLen = 2 * halfErrorBarW;
                  errorBarSegmentStartPos = crispX - halfErrorBarW;
                  for (l = trackerTolerance; l <= errorBarSegmentLen; l += (2 * trackerTolerance)) {
                    searchDataArr.push({
                      x: errorBarSegmentStartPos + l,
                      y: crispY,
                      r: trackerTolerance,
                      index: i,
                      data: dataObj,
                      toolText: segment.tooltext,
                      barType: 'v'
                    });
                  }
                } else {
                  errorPath = [
                    M, crispX, errorStartPos,
                    V, crispY
                  ];

                  errorBarSegmentLen = Math.abs(errorStartPos - crispY);
                  errorBarSegmentStartPos = errorStartPos > crispY ? crispY : errorStartPos;
                  for (l = trackerTolerance; l <= errorBarSegmentLen; l += (2 * trackerTolerance)) {
                    searchDataArr.push({
                      x: crispX,
                      y: errorBarSegmentStartPos + l,
                      r: trackerTolerance,
                      index: i,
                      data: dataObj,
                      toolText: segment.tooltext,
                      barType: 'v'
                    });
                  }
                }
              }
              attr = {
                path: errorPath,
                'stroke-width': visible ? errorBarThickness : 0,
                stroke: errorBarColor,
                'cursor': setLink ? POINTER : BLANK,
                'stroke-linecap': ROUND
              };
            }
            errorGraphicsString = ['error', errorBarType, subType, segmentType].join('-');
            if (!animState) {
              if (graphics[errorGraphicsString]) {
                animState = UPDATING;
              } else {
                animState = APPEARING;
              }
            }
            if (!graphics[errorGraphicsString] && animState === 'disappearing') {
              continue;
            }
            errorLineElem = graphics[errorGraphicsString] = animationManager.setAnimation({
              el: graphics[errorGraphicsString] || 'path',
              container: dataSet.getContainer('errorPlotGroup'),
              component: dataSet,
              attr: attr,
              state: animState,
              label: 'path',
              callback: dataSet.drawCallbackFn(animState)
            });
            (animState !== 'disappearing') && errorLineElem.show();
            // @todo has to validate how it works
            // why we need to set opacity while it is follower to main element
            errorLineElem.shadow({ opacity: animState === 'disappearing' ? 0 : conf.shadowOpacity }, dataSet.getContainer('errorShadowGroup'));
          }
        }
      }
    }
    searchDataArr.length && (this.config.dataTreeB = new KdTree().buildKdTree(searchDataArr));
    conf.initAnimation = false;
  }

  /*
         * Using kdtree algo for searching
        */
  _getHoveredPlot (x, y) {
    var res,
      res1,
      tooltext,
      errorBarToolText,
      hoverEffects,
      element;

    res = this.config.dataTree.getNeighbour({
      x: x,
      y: y
    }, true);

    // searching neighbour from Kdtree with basic search flag on
    if (res) {
      tooltext = res.data.config.toolText;
      res.data.config.finalTooltext = tooltext;
      hoverEffects = res.data.config.hoverEffects;
      element = res.data.graphics.element;
      element.data('hoverEnabled', hoverEffects.enabled);
      hoverEffects.enabled && element.attr(element.getData().setRolloverAttr);
      return {
        pointIndex: res.index,
        hovered: true,
        pointObj: res.data
      };
    }
    res1 = this.config.dataTreeB && this.config.dataTreeB.getNeighbour({
      x: x,
      y: y
    }, true);
    if (res1) {
      if (res1.barType === 'h') {
        errorBarToolText = res1.toolText;
      } else if (res1.barType === 'v') {
        errorBarToolText = res1.toolText;
      }
      res1.data.config.finalTooltext = errorBarToolText;
      element = res1.data.graphics.element;
      element.data('hoverEnabled', false);
      element.attr(element.getData().setRolloutAttr);
      return {
        pointIndex: res1.index,
        hovered: true,
        pointObj: res1.data
      };
    }
  }
  // Function to remove a data from a dataset during real time update.
  removePlots () {
    var dataSet = this,
      components = dataSet.components,
      removeDataArr = components.removeDataArr,
      pool = components.pool || (components.pool = {
        element: [],
        hotElement: [],
        label: []
      }),
      len = removeDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      removeData,
      graphics,
      i,
      key;

    for (i = 0; i < len; i++) {
      removeData = removeDataArr[0];
      removeDataArr.splice(0, 1);
      // In case of non existing data plot continue;
      if (!removeData || !removeData.graphics) {
        continue;
      }

      graphics = removeData.graphics;

      for (key in graphics) {
        if (graphics.hasOwnProperty(key)) {
          dataSet.getFromEnv('animationManager').setAnimation({
            el: graphics[key],
            component: dataSet,
            attr: {},
            state: 'disappering',
            callback: dataSet.removeCallbackFn
          });
        }
      }

      // Storing the graphic elements for reuse.
      removeData.graphics.element && (pool.element = pool.element.concat(removeData.graphics.element));
      removeData.graphics.label && (pool.label = pool.label.concat(removeData.graphics.label));
    }
    components.pool = pool;
  }
}
export default ErrorScatter;
